import React, { useEffect, useState } from 'react';
import { ArrowUp, MessageCircle, Cookie } from 'lucide-react';

export const FloatingWhatsApp = () => (
  <a
    className="fab-whatsapp"
    href="https://wa.me/905544356351"
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp"
  >
    <span className="fab-wa-icon">
      <MessageCircle size={16} />
    </span>
    Randevu Al
  </a>
);

export const ScrollTop = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <button
      className={`scroll-top ${visible ? 'visible' : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Yukarı"
    >
      <ArrowUp size={18} />
    </button>
  );
};

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const accepted = localStorage.getItem('cookie_accepted');
    if (!accepted) setShow(true);
  }, []);
  const accept = () => {
    localStorage.setItem('cookie_accepted', '1');
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="cookie-banner">
      <div className="cookie-head"><Cookie size={18} color="var(--accent)" /> Çerez Bildirimi</div>
      <div className="cookie-body">
        Deneyiminizi iyileştirmek için çerezler kullanıyoruz. Siteyi kullanmaya devam ederek bunu kabul etmiş sayılırsınız.
      </div>
      <div className="cookie-actions">
        <button className="cookie-accept" onClick={accept}>Kabul Et</button>
        <span className="cookie-link" onClick={accept}>Detaylar</span>
      </div>
    </div>
  );
};
